import Caption from "./Caption";
import Info from "./Info";
import LoadingCaption from "./Caption/LoadingCaption";
import SlideDefault from "./SlideDefault";
import SlidePlaceholder from "./SlidePlaceholder";
import SlideAudio from "./SlideAudio";
import SlideImage from "./SlideImage";
import SlideVideo from "./SlideVideo";
import SlideLoading from "./Loading";
import SlideInteractive from "./SlideInteractive";
import Zoom from "./Zoom";

export default {
  Caption,
  Info,
  LoadingCaption,
  SlideDefault,
  SlidePlaceholder,
  SlideAudio,
  SlideImage,
  SlideVideo,
  SlideInteractive,
  SlideLoading,
  Zoom
};
